import type { HTMLAttributes } from "react"
import { twMerge } from "tailwind-merge"

interface SanityTableProps {
  rows: {
    _key: string
    cells: string[]
  }[]
}

export const SanityTable = ({
  rows,
  className,
  ...boxProps
}: SanityTableProps & HTMLAttributes<HTMLDivElement>) => {
  const [headerRow, ...bodyRows] = rows

  return (
    <div
      className={twMerge(
        "rounded-tight border border-secondary max-w-full overflow-auto",
        className,
      )}
      {...boxProps}
    >
      <table className="w-full border-collapse">
        <thead className="bg-header">
          <tr>
            {headerRow.cells.map((cell, i) => (
              <th
                key={`${headerRow._key}-${i}`}
                className="sticky top-0 z-[1] bg-inherit px-sm py-sm text-left text-xs font-medium text-secondary border-b border-secondary first:pl-s last:pr-s"
              >
                {cell}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="[contain:strict]">
          {bodyRows.map(({ _key, cells }) => (
            <tr key={_key} className="bg-inherit">
              {cells.map((cell, i) => (
                <td
                  key={`${_key}-${i}`}
                  className={twMerge(
                    "px-sm py-sm text-left text-s text-secondary border-b border-secondary bg-primary first:pl-s last:pr-s [tr:has(td:empty)_&]:font-medium [tr:has(td:empty)_&]:text-primary",
                    i === cells.length - 1 && "border-b-0",
                  )}
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
